module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sales/sales.component.css
// module id = ./src/app/sales/sales.component.css
// module chunks = main